import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { useAtomValue } from 'jotai';
import Markdown from 'react-markdown';

import MarkdownLink from '@/components/MarkdownLink/MarkdownLink';
import { MARKDOWN_REMARK_PLUGINS } from '@/constants/markdown.constants';
import { caseDetailsAtom } from '@/pages/Case/Case.store';

import type { CaseDetailsMarkdownDialogProps } from './CaseDetailsMarkdownDialog.types';

const CaseDetailsMarkdownDialog = (props: CaseDetailsMarkdownDialogProps) => {
  const { open, setIsMarkdownDialogOpen } = props;
  const caseDetails = useAtomValue(caseDetailsAtom);

  const handleCopyMarkdown = () => {
    if (caseDetails?.ai_output?.ticket_text) {
      navigator.clipboard.writeText(
        caseDetails.ai_output.ticket_text as string
      );
    }
  };

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      onClose={() => setIsMarkdownDialogOpen(false)}
      open={open}
    >
      <DialogTitle>Case Details Markdown</DialogTitle>
      <DialogContent className="markdown-body">
        <Markdown
          disallowedElements={['img', 'a']}
          remarkPlugins={MARKDOWN_REMARK_PLUGINS}
          unwrapDisallowed
          components={{
            a: MarkdownLink
          }}
        >
          {caseDetails?.ai_output?.ticket_text as string}
        </Markdown>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCopyMarkdown} variant="contained">
          Copy Markdown
        </Button>
        <Button onClick={() => setIsMarkdownDialogOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaseDetailsMarkdownDialog;
